__turbopack_context__.v({
  "actionsWrapper": "_4R2eNq_actionsWrapper",
  "card": "_4R2eNq_card",
});
